var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-button"},[_c('div',{staticClass:"button-content",on:{"click":_vm.onClick}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.buttonText))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }